export default __webpack_public_path__ + "static/media/marigold.7ec4b58c.png";